import { useTranslation } from 'react-i18next';
import Metric, { MetricSize } from '../metric/Metric';
import styles from './InsightVI.module.scss';
import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import Skeleton from 'react-loading-skeleton';
import { VILevel, VISummaryModel } from '@customer/store/apis/interactionsApi';

type Nullable<T> = { [K in keyof T]: T[K] | null };

export interface InsightVIProps
  extends Nullable<Partial<Pick<VISummaryModel, 'alarm' | 'alert' | 'aware'>>> {
  vit: VISummaryModel['vit'];
}

export function InsightVI({ vit, alarm, alert, aware }: InsightVIProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.summary}>
      {vit ? (
        <div className={styles.summary__title}>{t(`vi.type.${vit}`)}</div>
      ) : (
        <Skeleton width={100} height={22} />
      )}
      <div className={styles.summary__metrics}>
        <Metric
          dataPrimary={alarm}
          label={t(`vi.level.${VILevel.Alarm}`)}
          status={BadgeStatus.Danger}
          size={MetricSize.L}
        />
        <Metric
          dataPrimary={alert}
          label={t(`vi.level.${VILevel.Alert}`)}
          status={BadgeStatus.Warning}
          size={MetricSize.L}
        />
        <Metric
          dataPrimary={aware}
          label={t(`vi.level.${VILevel.Aware}`)}
          status={BadgeStatus.Caution}
          size={MetricSize.L}
        />
      </div>
    </div>
  );
}

export default InsightVI;
